// extracted by mini-css-extract-plugin
module.exports = {"list":"LabelValueList_list__24tc5","mod1":"LabelValueList_mod1__1t830","label":"LabelValueList_label__4QMmb"};